import { FieldError } from './FieldError.js';

export function SelectField({
  name,
  value,
  onChange,
  options,
  placeholder,
  hasError,
  error,
  optionValue = 'value',
  optionLabel = 'label',
  disabled = false,
}) {
  const labelClasses = `flex flex-col p-3 bg-white border rounded-lg ${
    hasError ? 'border-coral-400' : 'border-charcoal-200'
  } focus-within:outline-charcoal-700 focus-within:outline-2 focus-within:outline`;

  return (
    <>
      <label className={labelClasses}>
        <span className="sr-only">{placeholder}</span>
        <select
          name={name}
          className="border-0 px-2 py-1 outline-none"
          value={value || ''}
          onChange={onChange}
          disabled={disabled}
        >
          <option value="">{placeholder}</option>
          {options.map((option) => {
            const optionValueKey =
              typeof option === 'object' ? option[optionValue] : option;
            const optionLabelKey =
              typeof option === 'object' ? option[optionLabel] : option;

            return (
              <option key={optionValueKey} value={optionValueKey}>
                {optionLabelKey}
              </option>
            );
          })}
        </select>
      </label>
      <FieldError error={error} />
    </>
  );
}
